import '@babel/polyfill'
import React, { StrictMode } from 'react'
import { render } from 'react-dom'
import Root from './containers/Root'
import boot from 'lib/boot'
import './index.css'
import { SITE_ANALYTICS_WRITEKEY } from './config'

function loadAnalyticsjs() {
  window.analytics.load(SITE_ANALYTICS_WRITEKEY)
}

boot()

render(
  <StrictMode>
    <Root />
  </StrictMode>,
  document.getElementById('root'),
  () => {
    // Load analytics.js after initial render and when the browser isn't busy
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadAnalyticsjs, {
        timeout: 7000
      })
    } else {
      loadAnalyticsjs()
    }
  }
)
